import { render } from "./AppNotifier.vue?vue&type=template&id=54462696&scoped=true&ts=true"
import script from "./AppNotifier.vue?vue&type=script&lang=ts"
export * from "./AppNotifier.vue?vue&type=script&lang=ts"

import "./AppNotifier.vue?vue&type=style&index=0&id=54462696&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54462696"]])

export default __exports__